module.exports = __webpack_public_path__ + "app-static/img/p_14.924e0e38.jpg";